import React from 'react'
import './footer.css'
import {FaFacebookSquare} from 'react-icons/fa'
import {FaTwitterSquare} from 'react-icons/fa'
import {FaLinkedin} from 'react-icons/fa'

const Footer = () => {
  return (
    <footer >
      <a href="#top" className='footer__logo'>MOKSEDUL</a>
      <ul className="permalinks">
        <li><a href="#top">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>

      <div className="footer__socials">
        <a href="https://linkedin.com/in/moksedul-alam/" target='_blank' rel='noreferrer'><FaLinkedin className='footer__social-icon' /></a>
        <a href="https://twitter.com/moksedul_engr" target='_blank' rel='noreferrer'><FaTwitterSquare className='footer__social-icon' /></a>
        <a href="https://facebook.com/engineer.moksedul" target='_blank' rel='noreferrer'><FaFacebookSquare className='footer__social-icon' /></a>
      </div>
      <div className="footer__copyright">
        <small>&copy; Moksedul Alam. All rights reserved</small>
      </div>
      

    </footer>
  )
}

export default Footer